import { CanDeactivateFn } from '@angular/router';
import { Signal } from '@angular/core';

export interface ComponentWithUnsavedChanges {
  hasUnsavedChanges: Signal<boolean>;
  confirmNavigation?: () => boolean | Promise<boolean>;
}

export const UnsavedChangesGuard: CanDeactivateFn<
  ComponentWithUnsavedChanges
> = component => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  if (component.confirmNavigation) {
    return component.confirmNavigation();
  }

  return true;
};
